import { render } from "./AssemblyTotalPlan.vue?vue&type=template&id=bc4eaee2&scoped=true"
import script from "./AssemblyTotalPlan.vue?vue&type=script&lang=js"
export * from "./AssemblyTotalPlan.vue?vue&type=script&lang=js"

import "./AssemblyTotalPlan.vue?vue&type=style&index=0&id=bc4eaee2&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc4eaee2"]])

export default __exports__